import Data from 'app-core/Data';
import ssmlHelper from 'view/insertion/ssml-helper';
import axios from 'axios';
import auth from 'auth';

function generateSSMLAudio(tracker, insertion, isPreview) {
	var sender = tracker;
	var ssmlPrepare = ssmlHelper.prepareSsml(insertion.Ssml, { ...Data.formatObjectToLowerCase(insertion), sender, isPreview });
	var loadParams = {
		Language: insertion.Language,
		Voice: ssmlPrepare.hasDefaultVoiceReplaced ? ssmlPrepare.voice : insertion.Voice,
		VoiceStyle: insertion.VoiceStyle,
		Rate: insertion.Rate,
		Pitch: insertion.Pitch,
		Ssml: ssmlPrepare?.ssml,
		Oid: insertion.Oid,
		ParentId: insertion.ParentId,
		CreativeId: insertion.CreativeId,
		TtsProviderType: insertion.TtsProviderType,
		ClientProcessId: auth.getGlobalProcessId(),
		VoiceSettings: insertion.VoiceSettings
	};

	if (__DEBUG__)
		console.debug('generateSSMLAudio', { tracker, insertion, isPreview });

	return new Promise((resolve, reject) => {
		return Data.postExternalApi('Creative/BuildAudioCustom', loadParams).then(data => {
			if (sender?._isDestroyed) return;
			if (__DEBUG__)
				console.info('Get audio data response', { data });

			if (data?.ErrorMessage) {
				sender?.$notifyError(`${sender?.$tCaption('An error occurred while generating speech:')} ${data?.ErrorMessage}`);
				reject(null);
				return null;
			} else {
				var base64 = `data:audio;base64,${data?.AudioData}`;
				axios.get(base64, {
					responseType: 'blob'
				}).then(r => {
					r.data.arrayBuffer()
						.then(arrayBuffer => {
							if (__DEBUG__) {
								console.debug('GenerateAudio load buffer', { arrayBuffer, length: arrayBuffer.length });
								window.response = arrayBuffer;
							}
							if (arrayBuffer.length === 0) return;

							tracker.audioContext.decodeAudioData(arrayBuffer, (buffer) => {
								if (__DEBUG__)
									console.debug('Generate audio decoded', { buffer });
								insertion.DynamicSsmlResult = data?.SsmlInsertion?.DynamicSsmlResult;
								insertion.Rate = data?.SsmlInsertion?.Rate || 1;
								insertion.JsonConfig.hasDefaultVoiceReplaced = ssmlPrepare?.hasDefaultVoiceReplaced;
								if (ssmlPrepare?.hasDefaultVoiceReplaced) {
									insertion.JsonConfig.defaultVoiceName = ssmlPrepare?.voice;
								}

								resolve({ buffer, base64: base64, blob: r.data });
							});
						});
				});
			}
		}).catch(ex => {
			if (__DEBUG__)
				console.debug('Get speech exception', { ex });
			reject(ex);
		});
	})
}

function generateAndSaveSSMLAudio(creativeDetail, track, isPreview, opts) {
	track.__isLoading++;
	if (__DEBUG__)
		console.debug('Update insertion SSML data generation started');
	return generateSSMLAudio(creativeDetail.$refs?.tracker, track.insertion, isPreview).then((res) => {
		var insertion = track.insertion;
		var buffer = res.buffer;
		var base64 = res.base64;
		if (__DEBUG__)
			console.debug('Update insertion SSML data generated', { track, buffer, base64, dur: buffer.duration });
		if (opts?.onAudioGenerated) opts.onAudioGenerated();
		if (base64) {
			var data = base64;
			creativeDetail.onInsertionSetTrack({
				insertion: insertion,
				track: track,
				trackId: track.id,
				buffer: buffer,
				base64: base64,
				isNew: false
			});
			track.__isLoading++;
			return creativeDetail.$azure.uploadInsertionAudio(insertion, data)
				.then(audio => {
					if (__DEBUG__)
						console.debug('SSML insertion uploaded', { audio, trackId: track.id, track });
					track.insertion.Audio = audio;
					creativeDetail.checkSimulateRulesAllTracks();
				})
				.catch((ex) => {
					console.error(ex);
					creativeDetail.$notifyError(ex);
				})
				.finally(() => track.__isLoading--)
		}
	})
	.catch(ex => console.error(ex))
	.finally(() => track.__isLoading--);
}

export default {
	generateSSMLAudio,
	generateAndSaveSSMLAudio
};
